/** @format */

import { patients, scheduling } from "lobbie";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import PatientSchedulingUserDetailsForm from "src/components/pages/patients/scheduling/dep/PatientSchedulingUserDetailsForm";
import { usePatientSelfSchedulingContext } from "src/hooks/patient_scheduling/usePatientSelfSchedulingContext";
import { setUser } from "src/redux/actions/userActions";
import { isEmailAutoGenerated, logDev } from "src/utils";

const PatientSchedulingUserInfo: React.FC = () => {
    const dispatch = useDispatch();

    const { selfSchedule, setSelfSchedule, setRoute, getNextRoute } =
        usePatientSelfSchedulingContext();

    const processPatient = useCallback(
        (patient: patients.IPatientAccountPatient) => {
            logDev("PatientSchedulingUserInfoV2.processPatient - patient -", patient);
            dispatch(setUser(patient));
            //@ts-ignore
            setSelfSchedule({
                ...selfSchedule,
                accountPatient:
                    patient.accountPatient !== undefined ? patient.accountPatient : null,
                email: isEmailAutoGenerated(patient.email) ? "" : patient.email,
                phone: patient.mobilePhone,
                isEmailConfirmed: patient.isEmailConfirmed ? patient.isEmailConfirmed : false,
                isPhoneConfirmed: patient.isPhoneConfirmed ? patient.isPhoneConfirmed : false,
            });
            setRoute(getNextRoute());
        },
        [getNextRoute, dispatch, setSelfSchedule, setRoute, selfSchedule],
    );

    const onSubmit = useCallback(
        (data: patients.IPatientAccountPatient | Record<string, any>) => {
            if (data) {
                if (data.isPatient || typeof data.patient === "boolean") {
                    processPatient(data as patients.IPatientAccountPatient);
                } else if (data.patient && typeof data.patient === "object") {
                    processPatient(data.patient as patients.IPatientAccountPatient);
                }
            }
        },
        [processPatient],
    );

    const handleChildrenResponseData = useCallback(
        (result: scheduling.patient.IAccountPatientSelectedAccountPatient): void => {
            //@ts-ignore
            setSelfSchedule({
                ...selfSchedule,
                accountPatient: result.accountPatient,
                selectedAccountPatient: result.selectedAccountPatient,
            });
            setRoute(getNextRoute());
        },
        [getNextRoute, selfSchedule, setRoute, setSelfSchedule],
    );

    return (
        <div className="col pt-4">
            <PatientSchedulingUserDetailsForm
                handlePatientCreateOrUpdateResponseData={onSubmit}
                handlePatientChildrenCreateOrUpdateResponseData={handleChildrenResponseData}
            />
        </div>
    );
};

export default PatientSchedulingUserInfo;
